<template>
    <div id="expedientecontenido-form-page">
        <div v-if="isLoading">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden"></span>
            </div>
        </div>
        <template v-else>
            <b-card :header="expedienteTitle" no-body>
                <slot name="default"></slot>
                <div class="p-2 pl-0">
                    <!-- d-md-none -->
                     <div class="d-md-none">
                         <b-tabs class="b-tabs-fix-order">
                             <b-tab v-for="tab in cTabs" :key="'tab-' + tab" :title="tab">
                                 <div v-for="question in cQuestions.filter(q => q.pregunta_grupo == tab)" :key="'c-question-' + question.id">
                                     <question-plain v-model="form.answers" :tipo="question.tipo" :question="question.pregunta" :expedienteItemId="question.id" :item="question" :readonly="readonly"/>
                                 </div>
                             </b-tab>
                             <b-tab title="Descripción">
                                 <b-jumbotron class="mb-0">
                                     <template #lead>
                                         {{ expedienteDescripcion || 'No hay descripción disponible para este expediente.' }}
                                     </template>
                                 </b-jumbotron>
                             </b-tab>
                         </b-tabs>
                     </div>
                    <!-- d-none d-md-block -->
                     <div class="d-none d-md-block">
                         <b-tabs class="b-tabs-fix-order" vertical pills>
                             <b-tab v-for="tab in cTabs" :key="'tab-' + tab" :title="tab">
                                 <div v-for="question in cQuestions.filter(q => q.pregunta_grupo == tab)" :key="'c-question-' + question.id">
                                     <question-plain v-model="form.answers" :tipo="question.tipo" :question="question.pregunta" :expedienteItemId="question.id" :item="question" :readonly="readonly"/>
                                 </div>
                             </b-tab>
                             <b-tab title="Descripción">
                                 <b-jumbotron class="mb-0">
                                     <template #lead>
                                         {{ expedienteDescripcion || 'No hay descripción disponible para este expediente.' }}
                                     </template>
                                 </b-jumbotron>
                             </b-tab>
                         </b-tabs>
                     </div>
                </div>
            </b-card>

            <b-card class="text-right p-0 mt-3" v-if="displaySubmit">
                <b-button type="submit" variant="primary">Guardar y finalizar</b-button>
            </b-card>

            <!-- Add your form components here -->
            <div class="debug" v-if="debug">
                <h1>Form</h1>
                <code><pre>{{ form }}</pre></code>
            </div>
            <div class="debug" v-if="debug">
                <h1>expedienteTemplate</h1>
                <code><pre>{{ asides.expedienteTemplate }}</pre></code>
            </div>
        </template>
    </div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import questionPlain from './question-plain.vue'

import { notify, mixedMSG } from '@/utils';

function asidesexpedienteTemplate(data = null) {
    if (data) {
        return data;
    } else {
        return {
            header: {
                id: null,
                expediente_id: null,
                version: null,
                subversion: null,
                estatus: null,
                created: null,
                modified: null,
                expediente_titulo: null,
                expediente_descripcion: null,
                expediente_version_title: null
            },
            expedienteItems: [
                // {
                //     "id": "14",
                //     "expediente_version_id": "1",
                //     "pregunta": "Fecha de nacimiento",
                //     "pregunta_grupo": "Datos previos",
                //     "tipo": "fecha",
                //     "unidades_numero": "",
                //     "opciones": null,
                //     "orden": "1",
                //     "created": "2025-04-07 22:57:47",
                //     "modified": "2025-04-07 22:57:47"
                // },
                // {
                //     "id": "17",
                //     "expediente_version_id": "1",
                //     "pregunta": "Estado Civil",
                //     "pregunta_grupo": "Datos previos",
                //     "tipo": "opcional",
                //     "unidades_numero": "",
                //     "opciones": "Soltero(a)\r\nCasado(a)\r\nDivorciado(a)\r\nViudo(a)\r\nUnión libre",
                //     "orden": "4",
                //     "created": "2025-04-07 22:57:47",
                //     "modified": "2025-04-07 22:57:47"
                // },
            ]
        };
    }
}

export default {
    name: 'ExpedientecontenidoFormPage',

    components: {
        questionPlain
    },

    props: {

        displaySubmit: {
            type: Boolean,
            default: false
        },

        readonly: {
            type: Boolean,
            default: false
        },

        debug: {
            type: Boolean,
            default: false
        },

        buildingURI: {
            type: String,
            default: () => { return 'expedientecontenido/fetch' }
        },

        hash: {
            type: String,
            required: true
        },

        expedienteVersionId: {
            type: [String, Number],
            default: null
        },

        usuarioExpedienteId: {
            type: [String, Number],
            default: null
        }

    },

    computed: {
        cTabs(){
             return [...new Set(this.asides.expedienteTemplate.expedienteItems.map(item => item.pregunta_grupo))];
        },
        cQuestions(){
            return this.asides.expedienteTemplate.expedienteItems;
        },
        expedienteDescripcion(){
            return this.asides.expedienteTemplate.header.expediente_descripcion;
        },
        expedienteTitle() {
            return this.asides.expedienteTemplate.header.expediente_version_title || '-- Expediente no encontrado --';
        },

        // Computed properties can be added here
        cURL() {
            return `${this.buildingURI}/${this.expedienteVersionId}/${this.usuarioExpedienteId}/${this.hash}`;
        },
    },

    data: () => {
        return {
            isLoading: false,
            isProcessing: false,
            form: {
                expedienteVersionId: null,
                usuarioExpedienteId: null,
                answers: [],
            },
            asides: {
                // Add any aside data here
                expedienteTemplate: asidesexpedienteTemplate()
            }
        }
    },

    methods: {
        getExpedienteAnswers(){
            return this.form.answers
        },
        handleExpediente(expediente){
            if('form' in expediente)
                this.form.answers = expediente.form.map(item => {
                    return {
                        expedienteItemId: item.expedienteItemId,
                        respuesta: item.respuesta,
                        fecha: item.fecha,
                        numero: item.numero
                    }
                });
            else
                this.form.answers = []
        },
        async loadUp() {
            this.isLoading = true;
            try {
                const response = await axios.get(this.cURL);

                if (!_.isObjectLike(response))
                    throw ('Error en la respuesta del server');

                if (response.status) {
                    this.asides.expedienteTemplate = asidesexpedienteTemplate(response.data.expedienteTemplate);
                    this.handleExpediente(response.data.expediente)
                } else {
                    this.asidesexpedienteTemplate = asidesexpedienteTemplate();
                }

                mixedMSG(response.status, response.msg, response.class);
            } catch (error) {
                notify(error);
            }
            this.isLoading = false;
        }
    },

    async mounted() {
        await this.loadUp();
    }

}
</script>

<style lang="scss">
#expedientecontenido-form-page {
    .b-tabs-fix-order {
        flex-flow: row-reverse;
        margin-left: 0px;
        .tab-pane {
            display: flex;
            flex-flow: column;
            gap: 1em;
            padding: 0.75em 0;
        }
    }
}
</style>